import { render, staticRenderFns } from "./NonIndividualApplications.vue?vue&type=template&id=66661a94&scoped=true&"
import script from "./NonIndividualApplications.vue?vue&type=script&lang=js&"
export * from "./NonIndividualApplications.vue?vue&type=script&lang=js&"
import style0 from "./NonIndividualApplications.vue?vue&type=style&index=0&id=66661a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66661a94",
  null
  
)

export default component.exports